import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import {
  Button,
  Dropdown,
  DropdownButton,
  Card,
  Row,
  Col,
  Form,
  Accordion,
} from "react-bootstrap";
import Loader from "../../components/Loader";
import AddFSRModal from "../../components/Modals/FsrModel";
import CheckpointStatusModal from "../../components/Modals/CheckpointStatusModal";
import CheckpointModal from "../../components/Modals/CheckpointModel";
import NoData from "../../components/NoData";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaEdit, FaPlus, FaTrashAlt } from "react-icons/fa";
import { TfiMenuAlt } from "react-icons/tfi";
import axios from "axios";
import { BASE_URL, HEADERS } from "../../utils/constant";
import { toast } from "react-toastify";
import { useCommonContext } from "../../utils/context";
import Pagination from "../../components/Pagination";
import CommonButton from "../../components/CommonButton";

function Fsr() {
  const [showAddFSRModal, setShowAddFSRModal] = useState(false);
  const [showCheckpointStatusModal, setShowCheckpointStatusModal] =
    useState(false);

  const { toggled } = useCommonContext();
  const [showCheckpointModal, setShowCheckpointModal] = useState(false);
  const [fsrData, setFsrData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchFSRText, setSearchFSRText] = useState("");
  const [editFSRData, setEditFSRData] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState({
    fsrId: null,
    categoryId: null,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const userPermissions = localStorage.getItem("user_permissions");

  useEffect(() => {
    fetchFsrs(currentPage);
  }, [searchFSRText, itemsPerPage, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchFSRText]);

  const fetchFsrs = async (page = 1) => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/fsrs/`, {
        headers: HEADERS,
        params: {
          page: page,
          page_size: itemsPerPage,
          search: searchFSRText || undefined,
        },
      });
      const fsrs = response.data.results || [];
      setFsrData(fsrs);
      setTotalPages(Math.ceil(response.data.total_pages));
      setCurrentPage(page);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setCurrentPage(1);
        fetchFsrs(1);
      } else {
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteFSR = async (id) => {
    try {
      await axios.delete(`${BASE_URL}/api/fsrs/${id}/`, { headers: HEADERS });
      toast.success("FSR deleted successfully!");

      fetchFsrs(currentPage);
    } catch (error) {
      toast.error("Error deleting FSR. Please try again.");
    }
  };

  const handleEditFSR = (data) => {
    setEditFSRData(data);
    setShowAddFSRModal(true);
  };

  const handleAddFSR = () => {
    setEditFSRData(null);
    setShowAddFSRModal(true);
  };

  const handleShowCheckpointModal = (fsrId, categoryId) => {
    setSelectedCategory({ fsrId, categoryId });
    setShowCheckpointModal(true);
  };

  const handlePageClick = (selectedPage) => {
    const newPage = selectedPage.selected + 1;
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  return (
    <div className="container-fluid ">
      <div className="mt-3 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
        <h4 className="mb-md-0">FSRs</h4>
        <div className="d-none d-md-flex align-items-center gap-2">
          <Form.Control
            type="text"
            value={searchFSRText}
            className="uniform-input search-text"
            placeholder="Search Here..."
            onChange={(e) => setSearchFSRText(e.target.value)}
          />

          {userPermissions.includes("fsr_add_fsr") && (
            <CommonButton className="uniform-button" onClick={handleAddFSR}>
              <FaPlus style={{ marginRight: "6px" }} /> Add
            </CommonButton>
          )}
        </div>
        <div className="d-md-none w-100">
          <Accordion flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Filters & Actions</Accordion.Header>
              <Accordion.Body>
                <div className="d-flex flex-column gap-3">
                  <Form.Group controlId="searchFSR">
                    <Form.Control
                      type="text"
                      value={searchFSRText}
                      placeholder="Search Here..."
                      className="uniform-input search-text"
                      onChange={(e) => setSearchFSRText(e.target.value)}
                      style={{
                        fontSize: "14px",
                        padding: "8px 12px",
                        borderRadius: "6px",
                      }}
                    />
                  </Form.Group>
                  {userPermissions.includes("fsr_add_fsr") && (
                    <CommonButton
                      className="uniform-button w-100 d-flex align-items-center justify-content-center"
                      onClick={handleAddFSR}
                    >
                      <FaPlus className="me-2" /> Add
                    </CommonButton>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>

      <div
        className={`table-responsive ${fsrData.length === 0 ? "" : "tabell"} `}
      >
        {loading ? (
          <Loader />
        ) : fsrData.length > 0 ? (
          <table className="table  tstart">
            <thead className="thead">
              <tr style={{ whiteSpace: "nowrap" }}>
                <th style={{ width: "250px" }}>FSR Name</th>
                <th style={{ width: "550px" }}>FSR Categories</th>
                <th style={{ width: "150px" }}></th>
              </tr>
            </thead>
            <tbody>
              {fsrData.map((fsr, index) => (
                <tr key={fsr.id}>
                  <td>
                    <div className="d-flex align-items-center ">
                      <span className="badge bg-primary text-white me-2">
                        {fsr.id}
                      </span>
                      <div title={fsr.fsrName || "—"} className="tdsubject">
                        {fsr.fsrName || "—"}
                      </div>
                    </div>
                  </td>
                  <td>
                    {fsr.categories.map((category) =>
                      category.name ? (
                        <span key={category.id} className="me-4">
                          <TfiMenuAlt
                            onClick={() =>
                              handleShowCheckpointModal(fsr.id, category.id)
                            }
                            style={{ color: "#3B71CA" }}
                            className="me-1"
                          />
                          {category.name}
                        </span>
                      ) : null,
                    )}
                  </td>

                  <td>
                    {(userPermissions.includes("fsr_change_fsr") ||
                      userPermissions.includes("fsr_delete_fsr")) && (
                      <div className="ms-auto">
                        <DropdownButton
                          id="dropdown-basic-button"
                          title={<BsThreeDotsVertical />}
                          variant="link"
                          className="p-0 text-secondary custom-dropdown"
                        >
                          {userPermissions.includes("fsr_change_fsr") && (
                            <Dropdown.Item onClick={() => handleEditFSR(fsr)}>
                              <FaEdit className="me-2" /> Edit
                            </Dropdown.Item>
                          )}
                          {userPermissions.includes("fsr_delete_fsr") && (
                            <Dropdown.Item
                              onClick={() => handleDeleteFSR(fsr.id)}
                            >
                              <span className="d-flex align-items-center text-danger">
                                <FaTrashAlt className="me-2" /> Delete
                              </span>
                            </Dropdown.Item>
                          )}
                        </DropdownButton>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <NoData message="No Data Found" height="400px" />
        )}
      </div>

      {fsrData.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          handlePageClick={handlePageClick}
          handleItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      {showAddFSRModal && (
        <AddFSRModal
          show={showAddFSRModal}
          handleClose={() => setShowAddFSRModal(false)}
          fetchFsrs={() => fetchFsrs(currentPage)}
          editFSRData={editFSRData}
          addFsrToList={(fsr) => setFsrData([...fsrData, fsr])}
          updateFsrInList={(updatedFsr) =>
            setFsrData(
              fsrData.map((fsr) =>
                fsr.id === updatedFsr.id ? updatedFsr : fsr,
              ),
            )
          }
        />
      )}
      {showCheckpointStatusModal && (
        <CheckpointStatusModal
          show={showCheckpointStatusModal}
          handleClose={() => setShowCheckpointStatusModal(false)}
        />
      )}
      {showCheckpointModal && (
        <CheckpointModal
          show={showCheckpointModal}
          handleClose={() => setShowCheckpointModal(false)}
          fsrId={selectedCategory.fsrId}
          categoryId={selectedCategory.categoryId}
        />
      )}
    </div>
  );
}

export default Fsr;
